import type { OptionallyResponsiveProp } from './responsiveProps'

export const getItemSpan = (
    itemCount: number
): OptionallyResponsiveProp<number> => {
    switch (itemCount) {
        case 1:
            return { _: 12 }
        case 2:
            return { _: 12, sm: 6 }
        case 3:
            return { _: 12, sm: 6, md: 4 }
        default:
            return { _: 12, sm: 6, md: 3 }
    }
}
